import { ChangeEvent, FC } from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import ModalDialog from '../../../../common/components/ModalDialog';
import ButtonGroup from '../../../../common/components/ButtonGroup';
import ExclusionComment from '../../../../elements/ExclusionComment/ExclusionComment';

const DisablePolicyModal: FC<
  React.PropsWithChildren<DisablePolicyModalProps>
> = ({
  open,
  onCloseDisablePolicy,
  handleDisablePolicy,
  isLoading,
  policyName,
  children,
  excludeComment,
  setExcludeComment,
}) => {
  const theme = useTheme();

  return (
    <ModalDialog
      modalColor={theme.palette.info.main}
      aria-label='Disable Policy'
      open={open}
      onClose={onCloseDisablePolicy}
      modalHeader='Disable Policy'>
      {children}
      <Box flexGrow={1} mb={2}>
        <Typography
          color={theme.palette.text.primary}
          variant='body1'
          component='div'>
          <p>Are you sure you want to disable the following policy?</p>
          <p style={{ fontWeight: 'bold' }}>{policyName}</p>
          <p>
            Please note that this will prevent issues related to the policy from
            being shown in future scans.
          </p>
        </Typography>
      </Box>
      <ExclusionComment
        excludeComment={excludeComment}
        setExcludeComment={setExcludeComment}
        message='Comment for this policy:'
      />
      <Box display='flex' alignItems='end'>
        <ButtonGroup
          onCancel={onCloseDisablePolicy}
          onClick={handleDisablePolicy}
          buttonCancelLabel='Cancel'
          buttonCancelTooltip='Click to cancel disabling'
          buttonActionLabel='Disable policy'
          buttonActionTooltip='Click to disable policy'
          isActionDisabled={false}
          isLoading={isLoading}
        />
      </Box>
    </ModalDialog>
  );
};

export interface DisablePolicyModalProps {
  open: boolean;
  onCloseDisablePolicy: () => void;
  handleDisablePolicy: () => void;
  isLoading: boolean;
  policyName?: string;
  excludeComment?: string;
  setExcludeComment: (e: ChangeEvent<HTMLTextAreaElement>) => void;
}

export default DisablePolicyModal;
